// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mv-3";
export var downloadButton = "_mv-4";
export var fileContainer = "_mv-9 _mv-7";
export var fileContainerBase = "_mv-7";
export var fileContainerFixedHeight = "_mv-8 _mv-7";
export var fileInfo = "_mv-5";
export var fileInfoWidthRestricted = "_mv-6";
export var fileType = "_mv-1";
export var fileTypeName = "_mv-2";
export var image = "_mv-0";
export var link = "_mv-b";
export var overflowEllipsis = "_mv-a";